import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_FAQ } from '../../../../../_entity/frequently-asked-question/ModuleFE_FAQ.js';
import './Renderer_FAQHeader.scss';
export class Renderer_FAQHeader extends ComponentSync {
    __onFAQsUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.faq?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ faq: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.faq?._id)
            state.faq = ModuleFE_FAQ.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'faq-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'faq-header__title', children: this.state.faq?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const faq = this.state.faq;
        if (!faq?.type)
            return;
        return _jsxs("span", { className: 'faq-header__sub-title', children: ["Type: ", faq.type] });
    };
}
//# sourceMappingURL=Renderer_FAQHeader.js.map